import { Injectable } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { address } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class SellersService {
  private ROOT_URL = address.API_SERVER_ADDRESS;

  constructor(private db: AngularFireDatabase, private http: HttpClient) { }

  async registerPickupProfile(payload) {
    const uri = this.ROOT_URL + '/shipmentglobal/registerpickuplocation';
    return this.http.post(uri, payload).toPromise();
  }
  get(sellerId) {
    return this.db.object('/seller-details/profiles/' + sellerId);
  }

  getUser(sellerId) {
    return this.db.object('/users/' + sellerId);
  }

  saveCustomUser(user, sellerName) {
    if (user.uid) {
      this.db.object('/users/' + user.uid).update({
        name: sellerName,
        email: user.email,
        creationDate: new Date().toLocaleString()
      });
    }
  }

  async getSubscriptionDetails(sellerId) {
    return this.http.get(this.ROOT_URL + "/payment/getsubscriptionDetails?sellerId=" + sellerId).toPromise();
  }

  async fetchProfileData(sellerId) {
    const uri = this.ROOT_URL + '/shipmentglobal/fetchProfileData?sellerId=' + sellerId;
    return this.http.get(uri).toPromise();
  }

}

